import playerUpMarkDark from '../assets/playerup-mark-dark.svg';

export function BrandMark() {
  return (
    <a className="brand-mark" href="/" aria-label="PlayerUp home">
      <img className="brand-mark__symbol" src={playerUpMarkDark} alt="" aria-hidden="true" />
      <span className="brand-mark__word">PlayerUp</span>
    </a>
  );
}
